import React, { useState, useEffect } from "react";
import { verifyAdminPin, isAuthenticated, setAuthenticated } from "../utils/auth";
import "../styles/AuthGuard.css";

const AuthGuard = ({ children }) => {
  const [authed, setAuthed] = useState(false);
  const [loading, setLoading] = useState(true);
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const [verifying, setVerifying] = useState(false);

  useEffect(() => {
    // Check if already authenticated
    if (isAuthenticated()) {
      setAuthed(true);
    }
    setLoading(false);
  }, []);

  const handleVerifyPin = async (e) => {
    e.preventDefault();
    setError("");

    if (!pin.trim()) {
      setError("Please enter the admin code");
      return;
    }

    if (pin.length !== 6) {
      setError("Admin code must be 6 digits");
      return;
    }

    setVerifying(true);
    try {
      const result = await verifyAdminPin(pin);
      if (result) {
        setAuthenticated(true);
        setAuthed(true);
      } else {
        setError("Incorrect admin code");
      }
    } catch (err) {
      console.error("Auth error:", err);
      setError("Failed to verify code. Try again.");
    } finally {
      setVerifying(false);
    }
  };

  if (loading) {
    return <div className="auth-loading">Loading...</div>;
  }

  if (authed) {
    return children;
  }

  return (
    <div className="auth-guard-container">
      <div className="auth-modal">
        <h1>🔐 Admin Access</h1>
        <p>Enter the 6-digit admin code to continue</p>

        <form onSubmit={handleVerifyPin} className="auth-form">
          <input
            type="password"
            value={pin}
            onChange={(e) => setPin(e.target.value.replace(/\D/g, "").slice(0, 6))}
            placeholder="000000"
            maxLength="6"
            disabled={verifying}
            autoFocus
            className="pin-input"
          />

          <button type="submit" disabled={verifying || pin.length !== 6} className="auth-button">
            {verifying ? "Verifying..." : "Verify"}
          </button>

          {error && <div className="auth-error">{error}</div>}
        </form>
      </div>
    </div>
  );
};

export default AuthGuard;
